export const blocklyEn = {
  CATEGORY_AUDIO: 'Audio',
  CATEGORY_LED: 'LED',
  CATEGORY_DISPLAY: 'Display',
  CATEGORY_MOTOR: 'Motor',
  CATEGORY_SENSOR: 'Sensor',
  CATEGORY_START: 'Event',
  CATEGORY_CONTROL: 'Control',
  CATEGORY_LOGIC: 'Logic',
  CATEGORY_MATH: 'Math',
  CATEGORY_LIST: 'List',
  CATEGORY_TEXT: 'Text',
  CATEGORY_IFZERO: 'iFZero',
  CATEGORY_IFLINE: 'iFLine',
  CATEGORY_MACHINE: 'Machine',
  CATEGORY_VARIABLE: 'Variable',
  CATEGORY_FUNCTION: 'Function',

  CUSTOM_START_ON_BOOT: '%1 on start %2 %3',
  CUSTOM_START_ON_BOOT_TOOLTIP: 'on start',
  CUSTOM_MACHINE_IFCONTROL: '%1 If %2 key is %4, %3 then run %6 %5',
  CUSTOM_MACHINE_IFCONTROL_V_ALL_BUTTONS: 'ALL BUTTONS',
  CUSTOM_MACHINE_IFCONTROL_V_UP: 'UP',
  CUSTOM_MACHINE_IFCONTROL_V_DOWN: 'DOWN',
  CUSTOM_MACHINE_IFCONTROL_V_LEFT: 'LEFT',
  CUSTOM_MACHINE_IFCONTROL_V_RIGHT: 'RIGHT',
  CUSTOM_MACHINE_IFCONTROL_V_ALL_ARROWS: 'ALL ARROWS',
  CUSTOM_MACHINE_IFCONTROL_V_PRESSED: 'pressed',
  CUSTOM_MACHINE_IFCONTROL_V_RELEASED: 'released',
  CUSTOM_MACHINE_IFCONTROL_TOOLTIP:
    'if iFControl key press or release, then run',
  CUSTOM_MACHINE_PIN: 'digital pin of number %1 and mode %2',
  CUSTOM_MACHINE_PIN_V_PIN_OUT: 'Pin.OUT',
  CUSTOM_MACHINE_PIN_V_PIN_IN: 'Pin.IN',
  CUSTOM_MACHINE_PIN_SET: 'digital write pin %1 to %2',

  CUSTOM_MACHINE_IFZERO_LED: '%1 LED %2',
  CUSTOM_MACHINE_IFZERO_LED_ON: 'on',
  CUSTOM_MACHINE_IFZERO_LED_OFF: 'off',
  CUSTOM_MACHINE_IFZERO_LED_TOOLTIP: 'iFZero LED on/off',
  CUSTOM_MACHINE_IFZERO_BUTTON: '%1 Button is %2, %3 then run %4',
  CUSTOM_MACHINE_IFZERO_BUTTON_V_PRESSED: 'pressed',
  CUSTOM_MACHINE_IFZERO_BUTTON_V_RELEASED: 'released',
  CUSTOM_MACHINE_IFZERO_BUTTON_TOOLTIP:
    'iFZero button press or release, then run',

  CUSTOM_MACHINE_IFZERO_GPIO_BUTTON:
    '%1 %2 pin, gpio Button is %3, %4 then run %5',
  CUSTOM_MACHINE_IFZERO_GPIO_BUTTON_V_PRESSED: 'pressed',
  CUSTOM_MACHINE_IFZERO_GPIO_BUTTON_V_RELEASED: 'released',
  CUSTOM_MACHINE_IFZERO_GPIO_BUTTON_TOOLTIP:
    'iFZero gpio button press or release, then run',

  CUSTOM_MACHINE_IFZERO_BMP_GET: '%1 BMP388 %2 sensor value',
  CUSTOM_MACHINE_IFZERO_BMP_GET_V_PRESSURE: 'pressure',
  CUSTOM_MACHINE_IFZERO_BMP_GET_V_TEMPERATURE: 'temperature',
  CUSTOM_MACHINE_IFZERO_BMP_GET_V_ALTITUDE: 'altitude',
  CUSTOM_MACHINE_IFZERO_BMP_GET_TOOLTIP:
    'iFZero BMP388 pressure, temperature, altitude sensor value',
  CUSTOM_MACHINE_IFZERO_MPU_GET: '%1 MPU9250 %2 sensor value',
  CUSTOM_MACHINE_IFZERO_MPU_GET_V_POSE: 'pose',
  CUSTOM_MACHINE_IFZERO_MPU_GET_V_ACCELERATION: 'acceleration',
  CUSTOM_MACHINE_IFZERO_MPU_GET_V_GYRO: 'gyro',
  CUSTOM_MACHINE_IFZERO_MPU_GET_V_MAGNETIC: 'magnetic',
  CUSTOM_MACHINE_IFZERO_MPU_GET_TOOLTIP:
    'iFZero MPU9250 acceleration, gyro, magnetic sensor value',

  CUSTOM_MACHINE_IFZERO_RGBLED_PIN:
    '%1 red %3 pin, green %4 pin, blue %5 pin to RGB LED %2',
  CUSTOM_MACHINE_IFZERO_RGBLED_PIN_TOOLTIP: 'iFZero pin to RGB LED',
  CUSTOM_MACHINE_IFZERO_RGBLED: '%1 %2 to RGB LED %3',
  CUSTOM_MACHINE_IFZERO_RGBLED_TOOLTIP: 'iFZero color to RGB LED',
  CUSTOM_MACHINE_IFZERO_PHOTORESISTOR: '%1 %2 pin, photoresistor value',
  CUSTOM_MACHINE_IFZERO_PHOTORESISTOR_TOOLTIP: 'iFZero get photoresistor value',
  CUSTOM_MACHINE_IFZERO_BUZZER: '%1 %3 duty, %4 frequency to buzzer of %2 pin',
  CUSTOM_MACHINE_IFZERO_BUZZER_TOOLTIP: 'iFZero buzzer',
  CUSTOM_MACHINE_IFZERO_ULTRASONIC:
    '%1 # %2, TRIG %3 pin, ECHO %4 pin, ultrasonic %5 sensor value',
  CUSTOM_MACHINE_IFZERO_ULTRASONIC_TOOLTIP: 'iFZero ultrasonic get value',
  CUSTOM_MACHINE_IFZERO_ULTRASONIC_V_NORMAL: 'normal',
  CUSTOM_MACHINE_IFZERO_ULTRASONIC_V_FILTERED: 'filtered',
  CUSTOM_MACHINE_IFZERO_LCD_PIN:
    '%1 LCD set RS %2 pin, EN %3 pin, D4 %4 pin, D5 %5 pin, D6 %6 pin, D7 %7 pin, %8 cols, %9 rows',
  CUSTOM_MACHINE_IFZERO_LCD_PIN_TOOLTIP: 'iFZero LCD set',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT: '%1 LCD print %2',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_TOOLTIP: 'iFZero LCD print message',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_EXT:
    '%1 LCD print %2 with align %3 at %4 line',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_EXT_TOOLTIP: 'iFZero LCD print message',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_LEFT: 'left',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_CENTER: 'center',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_RIGHT: 'right',
  CUSTOM_MACHINE_IFZERO_LCD_PRINT_V_EXTENTION: 'extention',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL: '%1 LCD %2',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_TOOLTIP: 'iFZero LCD control',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_CLEAR: 'clear all',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_HOME: 'move home',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_SHOW_UNDERLINE: 'show underline',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_HIDE_UNDERLINE: 'hide underline',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_SHOW_BLINK: 'show blink',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_HIDE_BLINK: 'hide blink',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_MOVE_LEFT: 'move left',
  CUSTOM_MACHINE_IFZERO_LCD_CONTROL_V_MOVE_RIGHT: 'move right',
  CUSTOM_MACHINE_IFZERO_LCD_CURSOR: '%1 LCD move cursor %2 col, %3 row',
  CUSTOM_MACHINE_IFZERO_LCD_CURSOR_TOOLTIP: 'iFZero LCD move cursor',
  CUSTOM_MACHINE_IFZERO_LCD_CHAR_1: 'LCD char',
  CUSTOM_MACHINE_IFZERO_LCD_CHAR_2: ',',
  CUSTOM_MACHINE_IFZERO_LCD_CHAR_3: 'print',
  CUSTOM_MACHINE_IFZERO_LCD_CHAR_TOOLTIP: 'iFZero LCD char',
  CUSTOM_MACHINE_IFZERO_TEMP_HUM: '%1 %2 pin, %3 sensor value',
  CUSTOM_MACHINE_IFZERO_TEMP_HUM_TOOLTIP:
    'iFZero temperature humidity sensor value',
  CUSTOM_MACHINE_IFZERO_TEMP_HUM_V_TEMPERATURE: 'temperature',
  CUSTOM_MACHINE_IFZERO_TEMP_HUM_V_HUMIDITY: 'humidity',
  CUSTOM_MACHINE_IFZERO_SERVO: '%1 %3 duty to servo motor of %2 pin',
  CUSTOM_MACHINE_IFZERO_SERVO_TOOLTIP: 'iFZero servo motor',

  CUSTOM_MACHINE_IFZERO_BATTERY_GET: '%1 battery voltage value',
  CUSTOM_MACHINE_IFZERO_BATTERY_GET_TOOLTIP: 'iFZero battery votage value',

  CUSTOM_MACHINE_IFLINE_MOTOR: '%1 %2',
  CUSTOM_MACHINE_IFLINE_MOTOR_FRONT: 'front',
  CUSTOM_MACHINE_IFLINE_MOTOR_BACK: 'back',
  CUSTOM_MACHINE_IFLINE_MOTOR_TURN_LEFT: 'turn left',
  CUSTOM_MACHINE_IFLINE_MOTOR_TURN_RIGHT: 'turn right',
  CUSTOM_MACHINE_IFLINE_MOTOR_TURN_REAR_LEFT: 'turn rear left',
  CUSTOM_MACHINE_IFLINE_MOTOR_TURN_REAR_RIGHT: 'turn rear right',
  CUSTOM_MACHINE_IFLINE_MOTOR_STOP: 'stop',
  CUSTOM_MACHINE_IFLINE_MOTOR_TOOLTIP:
    'iFLine front, back, turn left, turn right, stop',
  CUSTOM_MACHINE_IFLINE_MOTOR_SPEED: '%1 %3 %2 speed',
  CUSTOM_MACHINE_IFLINE_MOTOR_SPEED_V_BOTH: 'both wheel',
  CUSTOM_MACHINE_IFLINE_MOTOR_SPEED_V_LEFT: 'left wheel',
  CUSTOM_MACHINE_IFLINE_MOTOR_SPEED_V_RIGHT: 'right wheel',
  CUSTOM_MACHINE_IFLINE_MOTOR_SPEED_TOOLTIP: 'iFLine speed',
  CUSTOM_MACHINE_IFLINE_DISTANCE:
    'if iFLine ultrasonic sensors distance is %1 than %2 cm, then run %3',
  CUSTOM_MACHINE_IFLINE_DISTANCE_SHORT: 'shorter',
  CUSTOM_MACHINE_IFLINE_DISTANCE_LONG: 'longer',
  CUSTOM_MACHINE_IFLINE_DISTANCE_TOOLTIP:
    'if iFLine ultrasonic sensors distance is shorter or longer, then run',
  CUSTOM_MACHINE_IFLINE_DISTANCE_GET: '%1 ultrasonic sensors distance (cm)',
  CUSTOM_MACHINE_IFLINE_LED: '%1 %2 to %3 LED',
  CUSTOM_MACHINE_IFLINE_LED_TOOLTIP: 'iFLine color to LED',
  CUSTOM_MACHINE_IFLINE_IR_GET: '%1 %2 IR sensor value',
  CUSTOM_MACHINE_IFLINE_IR_GET_V_LEFTR: 'leftR',
  CUSTOM_MACHINE_IFLINE_IR_GET_V_LEFT: 'left',
  CUSTOM_MACHINE_IFLINE_IR_GET_V_RIGHT: 'right',
  CUSTOM_MACHINE_IFLINE_IR_GET_V_RIGHTR: 'rightR',
  CUSTOM_MACHINE_IFLINE_IR_GET_TOOLTIP:
    'iFLine leftR, left, right, rightR IR sensor value',

  CUSTOM_MACHINE_IFLINE_MORTOR_IR_RESET: '%1 mortor IR reset value',
  CUSTOM_MACHINE_IFLINE_MORTOR_IR_RESET_TOOLTIP: 'iFLine mortor IR reset value',

  CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET: '%1 %2 mortor IR sensor value',
  CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET_V_LEFT: 'left',
  CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET_V_RIGHT: 'right',
  CUSTOM_MACHINE_IFLINE_MORTOR_IR_GET_TOOLTIP:
    'iFLine left, right, reset mortor IR sensor value',

  CUSTOM_TIME_SLEEP: 'wait %1 %2',
  CUSTOM_TIME_SLEEP_SECOND: 's',
  CUSTOM_TIME_SLEEP_MILLISECOND: 'ms',
  CUSTOM_TIME_SLEEP_MICROSECOND: 'us',
  CUSTOM_TIME_SLEEP_TOOLTIP: 'wait seconds, mili seconds, micro seconds',
  CUSTOM_COMMON_COLOR: '%1 color',
  CUSTOM_COMMON_COLOR_TOOLTIP: 'color',
  CUSTOM_COMMON_COLOR_EXT: 'red %2, green %3, blue %4 %1 color',
  CUSTOM_COMMON_COLOR_EXT_TOOLTIP: 'color'
}

export const i18nEn = {
  Login: 'Login',
  Logout: 'Logout',
  Open: 'Open',
  Save: 'Save',
  Publish: 'Publish',
  Blocks: 'Blocks',
  Python: 'Python',
  Setting: 'Setting',
  Language: 'Language',
  'iFBlock Info': 'iFBlock Info',
  'Select Language': 'Select Language',

  Close: 'Close',
  Cancle: 'Cancle',
  Confirm: 'Confirm',
  'URL Edit': 'URL Edit',
  Detail: 'Detail',
  Back: 'Back',
  'User Info': 'User Info',
  Name: 'Name',
  Email: 'Email',
  'Change Password.': 'Change Password.',
  'Change Password': 'Change Password',
  'Leave iFBlock Service. Delete saved projects. Can not restore.':
    'Leave iFBlock Service. Delete saved projects. Can not restore.',
  Change: 'Change',
  Leave: 'Leave',
  'New Password': 'New Password',
  'Confirm New Password': 'Confirm New Password',
  'Confirm Leave iFBlock': 'Confirm Leave iFBlock',
  'Are you sure to leave?': 'Are you sure to leave?',

  'Login Success!': 'Login Success!',
  'Login Fail!': 'Login Fail!',
  'Logout Success!': 'Logout Success!',
  'Password Save Success!': 'Password Save Success!',
  'Leave iFBlock Success!': 'Leave iFBlock Success!',
  'Login Email verification': 'Login Email verification',
  'Check your Email Verification, Verification Email takes few minutes.':
    'Check your Email Verification, Verification Email takes few minutes.',
  'Login needs Email Verification!': 'Login needs Email Verification!',
  'Resend Verification Email': 'Resend Verification Email',

  'Copyright (C) INDIFROG 2021': 'Copyright (C) INDIFROG 2021',
  'Home Page': 'Home Page',
  'Build Date': 'Build Date',
  'The Nanum font provided by Naver is applied to this page.':
    'The Nanum font provided by Naver is applied to this page.',

  'New Project': 'New Project',
  'Save As': 'Save As',
  'Open Project': 'Open Project',
  'My Project': 'My Project',
  'Sample Project': 'Sample Project',
  'Date (Time)': 'Date (Time)',
  Date: 'Date',
  Rename: 'Rename',
  Delete: 'Delete',
  'Copy to Sample': 'Copy to Sample',
  'Save to Sample': 'Save to Sample',
  'Save Project': 'Save Project',
  'Project Name': 'Project Name',
  'Project Duplicate': 'Project Duplicate',
  'Project is already exist. Are you sure about saving it?':
    'Project is already exist. Are you sure about saving it?',
  'Delete Project': 'Delete Project',
  'Are you sure to delete the project?': 'Are you sure to delete the project?',
  'Rename Project': 'Rename Project',
  '{projectName} {messageType} Project is opened!':
    '{projectName} {messageType} Project is opened!',
  '{projectName} {messageType} Project is saved!':
    '{projectName} {messageType} Project is saved!',
  '{projectName} Project is renamed!': '{projectName} Project is renamed!',
  '{projectName} Project is removed!': '{projectName} Project is removed!',
  '{projectName} Project is copied to Sample!':
    '{projectName} Project is copied to Sample!',
  'Sample Project Detail': 'Sample Project Detail',
  'Project URL Edit': 'Project URL Edit',
  'Image URL': 'Image URL',
  'Circuit Diagram URL': 'Circuit Diagram URL',
  'Youtube URL': 'Youtube URL',
  'Youtube URL Start with': 'Youtube URL Start with',
  '{projectName} Project url is changed!':
    '{projectName} Project url is changed!',
  Sample: 'Sample',
  My: 'My',
  English: 'English',
  Korean: 'Korean',
  Untitled: 'Untitled',
  'Project Type': 'Project Type',
  'Device Type': 'Device Type',
  'Example Tab': 'Example Tab',
  'Add Device': 'Add Device',
  Add: 'Add',
  'Delete Device': 'Delete Device',
  'Are you sure to delete the device?': 'Are you sure to delete the device?',
  'Change Alert': 'Change Alert',
  'Changes may not be saved.': 'Changes may not be saved.',
  Help: 'Help'
}
